import interceptor from './interceptor';

//get all Project Statuses
const getAllProjectStatuses = () => {
  const request = interceptor.apiWithAuth.get('/projectstatus/get-all/');
  return request
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

const getProjectStatusByID = (projectStatusId: string) => {
  const request = interceptor.apiWithAuth.get(
    '/projectstatus/get-project-status-by-id/' + projectStatusId
  );
  return request
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

const getProjectStatusByName = (state: string) => {
  const request = interceptor.apiWithAuth.get(
    '/projectstatus/get-pitchdeckstatus-by-name/' + state
  );
  return request
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

const projectStatusService = {
  getAllProjectStatuses,
  getProjectStatusByName,
  getProjectStatusByID
};
export default projectStatusService;
